export const getTimeline = (estatusOrdenPagoID, ordenPago) => {
  const estatus = estatusOrdenPagoID || 0;

  const tieneValor = (valor) => {
    return valor && valor !== "" && valor !== null;
  };

  const crearHistorialDesdeRespuesta = (fecha, usuario) => {
    if (!tieneValor(fecha)) return null;
    return {
      fecha: fecha,
      nombre: tieneValor(usuario) ? usuario : null
    };
  };

  const ordenCreada = crearHistorialDesdeRespuesta(
    ordenPago?.fechaCreacion,
    ordenPago?.usuarioCreacion
  );

  const autorizaciones = [];

  if (tieneValor(ordenPago?.fechaAutorizacionContencion)) {
    autorizaciones.push({
      fecha: ordenPago.fechaAutorizacionContencion,
      nombre: tieneValor(ordenPago?.usuarioAutorizacionContencion) ? ordenPago.usuarioAutorizacionContencion : null,
      comentario: 'Autorizada Contención nivel'
    });
  }

  if (tieneValor(ordenPago?.fechaAutorizacionPago)) {
    autorizaciones.push({
      fecha: ordenPago.fechaAutorizacionPago,
      nombre: tieneValor(ordenPago?.usuarioAutorizacionPago) ? ordenPago.usuarioAutorizacionPago : null,
      comentario: 'Autorizada Primer nivel'
    });
  }

  if (tieneValor(ordenPago?.fechaAutorizacionPago2)) {
    autorizaciones.push({
      fecha: ordenPago.fechaAutorizacionPago2,
      nombre: tieneValor(ordenPago?.usuarioAutorizacionPago2) ? ordenPago.usuarioAutorizacionPago2 : null,
      comentario: 'Autorizada Segundo nivel'
    });
  }

  const facturaSolicitada = crearHistorialDesdeRespuesta(
    ordenPago?.fechaSolicitudFactura,
    ordenPago?.usuarioSolicitudFactura
  );

  const facturaRecibida = crearHistorialDesdeRespuesta(
    ordenPago?.fechaCargaFactura,
    ordenPago?.usuarioCargaFactura
  );

  const facturaValidada = crearHistorialDesdeRespuesta(
    ordenPago?.fechaSolicitudPago,
    ordenPago?.usuarioSolicitudPago
  );

  const facturaPagada = crearHistorialDesdeRespuesta(
    ordenPago?.fechaPagado,
    ordenPago?.nombreUsuarioPagado
  );

  const complementoRecibido = crearHistorialDesdeRespuesta(
    ordenPago?.fechaCargaComplementoPago,
    ordenPago?.usuarioCargaComplementoPago
  );

  return [
    { estado: 'Orden Creada', completado: estatus >= 1, orden: 1, historial: ordenCreada },
    { estado: 'Orden Validada', completado: estatus >= 2, orden: 2, historial: autorizaciones.length > 0 ? autorizaciones : null },
    { estado: 'Factura Solicitada', completado: estatus >= 3, orden: 3, historial: facturaSolicitada },
    { estado: 'Factura Recibida', completado: estatus >= 4, orden: 4, historial: facturaRecibida },
    { estado: 'Factura Validada', completado: estatus >= 5, orden: 5, historial: facturaValidada },
    { estado: 'Factura Pagada', completado: estatus >= 6, orden: 6, historial: facturaPagada },
    { estado: 'Complemento de Pago Recibido', completado: estatus >= 7, orden: 7, historial: complementoRecibido }
  ];
};
